/* HPN Listicle - Video Slider */
(() => {
  if (window.__hpnListicleVideoSliderLoaded) return;
  window.__hpnListicleVideoSliderLoaded = true;

  const ROOT_SELECTOR = '.hpn-listicle-video-slider';
  const SLIDER_SELECTOR = '[data-hpn-listicle-video-slider-slider]';
  const CARD_SELECTOR = '[data-hpn-listicle-video-slider-video-card]';

  function getSliderState(slider) {
    if (!slider.__hpnListicleVideoSliderState) {
      slider.__hpnListicleVideoSliderState = {
        index: 0,
        autoplayId: null,
        resizeFrame: null,
        resizeHandler: null,
      };
    }

    return slider.__hpnListicleVideoSliderState;
  }

  function getSlides(slider) {
    return Array.from(slider.querySelectorAll('.hpn-listicle-video-slider__slide'));
  }

  function getTrack(slider) {
    return slider.querySelector('.hpn-listicle-video-slider__wrapper');
  }

  function getViewport(slider) {
    return slider.querySelector('.hpn-listicle-video-slider__swiper');
  }

  function getVisibleSlides(slider) {
    const width = window.innerWidth;

    if (width >= 1200) {
      return parseInt(slider.dataset.largeDesktopSlides || '5', 10);
    }

    if (width >= 1024) {
      return parseInt(slider.dataset.desktopSlides || '3', 10);
    }

    if (width >= 768) {
      return parseInt(slider.dataset.tabletSlides || '2', 10);
    }

    const mobileValue = parseInt(slider.dataset.mobileSlides || '12', 10);
    return mobileValue >= 10 ? mobileValue / 10 : mobileValue;
  }

  function getMaxIndex(slider) {
    const slides = getSlides(slider);
    const visibleSlides = getVisibleSlides(slider);

    return Math.max(0, Math.ceil(slides.length - visibleSlides));
  }

  function clampIndex(slider, index) {
    const maxIndex = getMaxIndex(slider);

    if (index < 0) return maxIndex;
    if (index > maxIndex) return 0;

    return index;
  }

  function updateDots(slider) {
    const dots = Array.from(slider.querySelectorAll('.hpn-listicle-video-slider__dot'));
    const state = getSliderState(slider);

    dots.forEach((dot, index) => {
      const isActive = index === state.index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function goToSlide(slider, index) {
    const track = getTrack(slider);
    const viewport = getViewport(slider);
    const slides = getSlides(slider);

    if (!slider || !track || !viewport || !slides.length) return;

    const state = getSliderState(slider);
    const nextIndex = clampIndex(slider, index);
    const targetSlide = slides[nextIndex];

    if (!targetSlide) return;

    state.index = nextIndex;

    const maximumOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);
    const targetOffset = Math.min(targetSlide.offsetLeft, maximumOffset);

    track.style.transform = `translate3d(-${targetOffset}px, 0, 0)`;
    updateDots(slider);
  }

  function buildDots(slider) {
    const pagination = slider.querySelector('[data-hpn-listicle-video-slider-pagination]');
    const slides = getSlides(slider);

    if (!pagination || !slides.length) return;

    pagination.innerHTML = '';

    const maxIndex = getMaxIndex(slider);

    for (let index = 0; index <= maxIndex; index += 1) {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'hpn-listicle-video-slider__dot';
      dot.setAttribute('aria-label', `Go to video ${index + 1}`);

      dot.addEventListener('click', () => {
        stopAutoplay(slider);
        goToSlide(slider, index);
      });

      pagination.appendChild(dot);
    }

    updateDots(slider);
  }

  function rebuildSlider(slider) {
    buildDots(slider);
    goToSlide(slider, getSliderState(slider).index);
  }

  function startAutoplay(slider) {
    if (!slider || slider.dataset.autoplay !== '1' || document.hidden) return;

    const state = getSliderState(slider);
    const delay = parseInt(slider.dataset.autoplayDelay || '4000', 10);
    const autoplayDelay = Number.isFinite(delay) && delay >= 1000 ? delay : 4000;

    stopAutoplay(slider);

    state.autoplayId = window.setInterval(() => {
      goToSlide(slider, getSliderState(slider).index + 1);
    }, autoplayDelay);
  }

  function stopAutoplay(slider) {
    if (!slider) return;

    const state = getSliderState(slider);

    if (state.autoplayId) {
      window.clearInterval(state.autoplayId);
      state.autoplayId = null;
    }
  }

  function stopVideo(card) {
    if (!card) return;

    const video = card.querySelector('.hpn-listicle-video-slider__video');
    const overlay = card.querySelector('.hpn-listicle-video-slider__video-overlay');
    const playButton = card.querySelector('.hpn-listicle-video-slider__play-button');

    if (!video || !overlay || !playButton) return;

    video.pause();

    try {
      video.currentTime = 0;
    } catch (error) {}

    card.dataset.isPlaying = 'false';
    overlay.classList.remove('is-hidden');
    playButton.classList.remove('is-hidden');
    video.classList.remove('is-playing');
  }

  function stopAllVideos(root) {
    if (!root) return;

    root.querySelectorAll(`${CARD_SELECTOR}[data-is-playing="true"]`).forEach(stopVideo);
  }

  function loadVideo(card, forceAutoPreload = false) {
    if (!card) return;

    const video = card.querySelector('.hpn-listicle-video-slider__video');
    const videoSrc = card.dataset.videoSrc;

    if (!video || !videoSrc || card.dataset.videoLoaded === 'true') return;

    video.src = videoSrc;
    video.preload = forceAutoPreload ? 'auto' : 'metadata';
    video.load();

    card.dataset.videoLoaded = 'true';
  }

  async function playVideo(root, card) {
    if (!root || !card) return;

    const slider = card.closest(SLIDER_SELECTOR);
    const video = card.querySelector('.hpn-listicle-video-slider__video');
    const overlay = card.querySelector('.hpn-listicle-video-slider__video-overlay');
    const playButton = card.querySelector('.hpn-listicle-video-slider__play-button');

    if (!video || !overlay || !playButton || !card.dataset.videoSrc) return;

    stopAllVideos(root);
    stopAutoplay(slider);

    loadVideo(card, true);

    try {
      video.currentTime = 0;
      await video.play();

      card.dataset.isPlaying = 'true';
      overlay.classList.add('is-hidden');
      playButton.classList.add('is-hidden');
      video.classList.add('is-playing');
    } catch (error) {
      stopVideo(card);
      startAutoplay(slider);
    }
  }

  function initCards(root) {
    if (!root) return;

    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (!card.dataset.initialized) {
        card.dataset.initialized = 'true';
        card.dataset.isPlaying = 'false';
      }

      if (card.dataset.hasCustomPoster === 'false') {
        loadVideo(card, false);
      }
    });
  }

  function bindVideoEvents(root) {
    if (!root || root.__hpnListicleVideoSliderEventsBound) return;

    root.__hpnListicleVideoSliderEventsBound = true;

    root.addEventListener(
      'click',
      (event) => {
        const playButton = event.target.closest('.hpn-listicle-video-slider__play-button');
        const card = event.target.closest(CARD_SELECTOR);

        if (playButton && card && root.contains(card)) {
          event.preventDefault();
          event.stopPropagation();
          playVideo(root, card);
          return;
        }

        if (card && card.dataset.isPlaying === 'true') {
          const slider = card.closest(SLIDER_SELECTOR);

          event.preventDefault();
          event.stopPropagation();
          stopVideo(card);
          startAutoplay(slider);
        }
      },
      true
    );

    root.addEventListener(
      'ended',
      (event) => {
        if (!event.target.classList.contains('hpn-listicle-video-slider__video')) return;

        const card = event.target.closest(CARD_SELECTOR);
        const slider = card ? card.closest(SLIDER_SELECTOR) : null;

        stopVideo(card);
        startAutoplay(slider);
      },
      true
    );
  }

  function initSlider(root, slider) {
    if (!root || !slider || slider.__hpnListicleVideoSliderBound) return;

    slider.__hpnListicleVideoSliderBound = true;

    const track = getTrack(slider);
    const slides = getSlides(slider);
    const prevButton = slider.querySelector('[data-hpn-listicle-video-slider-prev]');
    const nextButton = slider.querySelector('[data-hpn-listicle-video-slider-next]');
    const state = getSliderState(slider);

    if (!track || !slides.length) return;

    track.style.transform = 'translate3d(0, 0, 0)';

    buildDots(slider);
    goToSlide(slider, 0);

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        stopAutoplay(slider);
        goToSlide(slider, getSliderState(slider).index - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        stopAutoplay(slider);
        goToSlide(slider, getSliderState(slider).index + 1);
      });
    }

    state.resizeHandler = () => {
      if (state.resizeFrame) window.cancelAnimationFrame(state.resizeFrame);

      state.resizeFrame = window.requestAnimationFrame(() => {
        rebuildSlider(slider);
        state.resizeFrame = null;
      });
    };

    window.addEventListener('resize', state.resizeHandler);
    startAutoplay(slider);
  }

  function destroySlider(slider) {
    if (!slider) return;

    const state = getSliderState(slider);
    stopAutoplay(slider);

    if (state.resizeFrame) {
      window.cancelAnimationFrame(state.resizeFrame);
      state.resizeFrame = null;
    }

    if (state.resizeHandler) {
      window.removeEventListener('resize', state.resizeHandler);
      state.resizeHandler = null;
    }

    slider.__hpnListicleVideoSliderBound = false;
  }

  function initSection(root) {
    if (!root) return;

    bindVideoEvents(root);
    initCards(root);

    root.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => {
      initSlider(root, slider);
    });
  }

  function init(scope = document) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      initSection(scope);
      return;
    }

    scope.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.(ROOT_SELECTOR)
      ? [event.target]
      : Array.from(event.target.querySelectorAll?.(ROOT_SELECTOR) || []);

    roots.forEach((root) => {
      stopAllVideos(root);
      root.querySelectorAll(SLIDER_SELECTOR).forEach(destroySlider);
    });
  });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (document.hidden) {
        stopAllVideos(root);
        root.querySelectorAll(SLIDER_SELECTOR).forEach(stopAutoplay);
        return;
      }

      root.querySelectorAll(SLIDER_SELECTOR).forEach(startAutoplay);
    });
  });

  if (document.readyState !== 'loading') {
    init(document);
  }
})();
